// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__22xHx","inner":"Footer_inner__2pQVB"};